export const showSidebar = (data) => {
  return { type: "SIDEBAR_OPEN", data };
};
